import React from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import Icon from 'meinian-package/src/component/icon'
import { request } from 'meinian-package/src/utils'
import classNames from 'classnames'
import { getSampleStatusText } from './common'
import './index.less'

const SampleCardExamine = ({ process, id, stepId, stepStatus, onClick }) => {
  const _onClick = (newData) => {
    onClick?.(newData)
  }
  const isComputeAll = () => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    return stepStatus === -1 || (process?.steps?.length === process?.steps?.findIndex(item => item.id === stepId) + 1 && stepStatus === 3)
  }
  const isStart = () => {
    return stepStatus === 0 || stepStatus === 2
  }

  if (isComputeAll()) {
    return null
  }
  return <div className="mn-sample-card-examine">
    <div className="mn-sample-card-examine-operation">
      {!isStart() && <SampleCardExamine.Recall id={id} onClick={_onClick} />}
      <SampleCardExamine.Process process={process} id={id} stepId={stepId} stepStatus={stepStatus} onClick={_onClick} />
    </div>
  </div>
}

SampleCardExamine.Recall = ({ className, id, onClick }) => {
  const onUpdateSampleStatus = async (status, e) => {
    e.stopPropagation()
    try {
      const res = await request.post('/zhikuan/mn/sample/update-step-status', {
        sampleId: id,
        stepStatus: status
      })
      if (res) {
        onClick?.(res)
      }
    } catch (err) {
      console.error(err)
    }
  }
  return <div className={classNames('mn-sample-card-examine-operation-recall', 'fill-white-bg', className)} onClick={(e) => onUpdateSampleStatus(2, e)}><Icon type="m-chehui" /></div>
}

SampleCardExamine.Process = ({ className, process = {}, id, stepId, stepStatus, onClick }) => {
  const onUpdateSampleStatus = async (status, e) => {
    e.stopPropagation()
    try {
      const res = await request.post('/zhikuan/mn/sample/update-step-status', {
        sampleId: id,
        stepStatus: status
      })
      if (res) {
        onClick?.(res)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const isEnd = process ? process?.steps?.length === (process.steps.findIndex(item => item.id === stepId) + 1) : true

  const rendDom = () => {
    if (stepStatus !== -1) {
      if ((stepStatus === 0 || stepStatus === 2) && !isEnd) {
        return <Button
          onClick={(e) => onUpdateSampleStatus(1, e)}
          className={classNames('mn-sample-card-examine-operation-btn', className)}
        >开始{getSampleStatusText({ process, stepId, stepStatus })}</Button>
      }
      return <Button
        onClick={(e) => onUpdateSampleStatus(0, e)}
        className={classNames('mn-sample-card-examine-operation-btn', className)}
      >完成{getSampleStatusText({ process, stepId, stepStatus })}</Button>
    }
    return null
  }

  return <>
    {rendDom()}
  </>
}

export default SampleCardExamine
